import { useState } from "react";
import fetcher from "../helper/fetcher";
import { useSnackbar } from "../context/SnackBarContext";

export const useDirectSale = (onClose, setRefetch) => {
    const { showError, showSuccess } = useSnackbar()
    const [isLoading, setIsLoading] = useState(false)

    const directSale = (payload, id) => {
        setIsLoading(true)
        fetcher.post(`/inventory/direct_sale/create_direct_sale/${id}`, payload)
            .then((res) => {
                showSuccess("Data saved Successfully")
            })
            .catch((err) => {
                showError(err.response.data.message || "Failed to Save Data")
            }).finally(() => {
                onClose()
                setRefetch((prev)=> prev + 1)
                setIsLoading(false)
            })
    }

    return { directSale, isLoading }
}